import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { FormSelectSelectionLabel } from './FormSelectSelectionLabel';

export type FormSelectOptionDisplayLabelProps = PropsWithChildren;

export const FormSelectSelectionPlaceholder: FC<
  FormSelectOptionDisplayLabelProps
> = (props) => (
  <PlaceholderWrapper>
    <FormSelectSelectionLabel supertitle=" " role="none">
      {' '}
    </FormSelectSelectionLabel>
    <span>{props.children}</span>
  </PlaceholderWrapper>
);

const PlaceholderWrapper = styled.div`
  position: relative;

  > span {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
  }
`;
